export const convertImageToPng = (file: File, fileName?: string): Promise<File> => {
  return new Promise((resolve, reject) => {
    // Check if file is already PNG
    if (file.type === "image/png") {
      resolve(file);
      return;
    }

    const reader = new FileReader();

    reader.onload = e => {
      const img = new Image();

      img.onload = () => {
        // Create canvas with image dimensions
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw image on canvas
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          reject(new Error("Failed to get canvas context"));
          return;
        }

        ctx.drawImage(img, 0, 0);

        // Convert canvas to PNG blob
        canvas.toBlob(
          blob => {
            if (!blob) {
              reject(new Error("Failed to convert image to PNG"));
              return;
            }

            // Create PNG filename
            const originalName = file.name.replace(/\.[^/.]+$/, "");
            const pngFileName = fileName || `${originalName}.png`;

            // Create new File object from blob
            const pngFile = new File([blob], pngFileName, {
              type: "image/png",
              lastModified: Date.now()
            });

            resolve(pngFile);
          },
          "image/png",
          1.0 // Maximum quality
        );
      };

      img.onerror = () => {
        reject(new Error("Failed to load image"));
      };

      img.src = e.target?.result as string;
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsDataURL(file);
  });
};

export const renameFileName = (file: File, newName: string): File => {
  const extension = file.name.split(".").pop() || "";
  const fileName = extension ? `${newName}.${extension}` : newName;
  return new File([file], fileName, {
    type: file.type,
    lastModified: file.lastModified
  });
};

export const getFileExtension = (filename: string) => {
  const parts = filename.split(".");
  return parts.length > 1 ? parts.pop() : "";
};

export const renameFile = (file: File, newName: string): File => {
  const extension = getFileExtension(file.name);
  const fileName = extension ? `${newName}.${extension}` : newName;
  return new File([file], fileName, {
    type: file.type,
    lastModified: file.lastModified
  });
};
